import React, {useEffect, useRef, useState} from "react";

import './RevealMainPage.css'
import backgroundImage from "asset/video/parplay_3bit.mp4";
import {useSelector} from "react-redux";

function RevealMainPage(props) {
    const walletConnected = useSelector(state => state.walletSlice.connected);
    const {walletConnectFunc} = props;
    const btnCenter = () => {
        if(walletConnected){
            return (
                <div className={"center-text"}>
                    REVEAL
                </div>
            );
        }else{
            return (
                <div className={"center-btn"}
                    onClick={()=>{walletConnectFunc("havah")}}>
                    <svg className={"center-svg"} xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="Gradient" x1="0" x2="80" y1="0" y2="0" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#A02FD0" offset="0"/>
                                <stop stopColor="#601DE6" offset="1"/>
                            </linearGradient>
                        </defs>
                        <rect x="1" y="1" height="100%" width="100%" style={{width:"calc(100% - 2px)",height:"calc(100% - 2px)"}} rx="5" ry="5" strokeWidth="2" fill="transparent" stroke="url(#Gradient)"/>
                    </svg>
                    Connect Wallet
                </div>
            );
        }

    }
    /* 메인 중앙 부분 */
    return (
        <div className={"main-page"}
        >
            <div className={"slider-area"}>
                <video
                    className={"background-image"}
                    autoPlay={true}
                    muted={true}
                    loop={true}
                    playsInline={true}
                    preload={"metadata"}
                >
                    <source src={backgroundImage} type={"video/mp4"}/>
                </video>
            </div>
            <div className={"center-container"}>
                <div className={"center-content"}>
                    {btnCenter()}
                </div>
            </div>
        </div>
    )
}

export default RevealMainPage;